import {
  crudRequest,
  crudRequest2,
  getSitePlan
} from '@/services/api';

import { getToDay } from '@/utils/date';
import moment from 'moment';

const paramsForm = {
  dateRange: getToDay(),
  centerFilter: '',
  centerFilterCode: ''
}

export default {
  namespace: 'centerWeightViewSite',
  state: {
    dateRange: paramsForm.dateRange,
    centerFilter: paramsForm.centerFilter,
    defualtDateFormat: 'YYYY-MM-DD HH:mm:00',
    sitePlan: [], // 上站已发
    isTmsLoading: false, // tms 接口是否加载完成
    actualDepartureCarsItem: [],  // 已发出 tms
    planDepartureCarsItem: [], // 计划发
    volumeItem: [], // 运力
  },
  effects: {
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
      crudRequest('/api/route/centerweightviewSite/search')
      yield put({ type: 'centerWeightViewOutletsTables/getSelect' });
    },
    *getTms(_, { call, put, select }) {
      let sitePlanParams = yield select(({ centerWeightViewOutletsTables, centerWeightViewSite }) => ({
        preSiteFlag: centerWeightViewOutletsTables.showPreSiteFlag ? 1 : 0,
        departureCenterCode: centerWeightViewSite.centerFilterCode,
        departureCenter: centerWeightViewSite.centerFilter,
        startDate: moment(centerWeightViewSite.dateRange[0]).format(centerWeightViewSite.defualtDateFormat),
        endDate: moment(centerWeightViewSite.dateRange[1]).format(centerWeightViewSite.defualtDateFormat),
      }));
      // tms
      yield put({
        type: 'update',
        payload: { isTmsLoading: false },
      });
      let query = yield select(({ centerWeightViewSite }) => {
        return {
          locationName: centerWeightViewSite.centerFilter,
          startTime: moment(centerWeightViewSite.dateRange[0]).format(centerWeightViewSite.defualtDateFormat),
          endTime: moment(centerWeightViewSite.dateRange[1]).format(centerWeightViewSite.defualtDateFormat),
        }
      });
      const start = moment(query.startTime).day();
      const departure = yield call(crudRequest2, {
        period: start === 0 ? 7 : start,
        departureCenter: query.locationName,
      });
      // const sitePlan = yield call(getSitePlan, sitePlanParams)
      const volumeItem = departure.data && departure.data.length > 0 ? departure.data : []
      yield put({
        type: 'update',
        payload: {
          // sitePlan: sitePlan?.data,
          isTmsLoading: true,
          volumeItem: volumeItem
        },
      });
    }
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}
